// Small pure helpers for `EInvoiceProposalRequest.tsx` (048), kept apart so the
// component stays under the web 400-line rule.

import type { BillingMethod } from '../../membership-billing/MembershipBillingPort.js';

/** The delivery-method row's copy. `unknown` states it plainly, never a guess (FR-001a). */
export const METHOD_LABEL_KEYS = {
  paper: 'profile.fee.eInvoice.methodPaper',
  einvoice: 'profile.fee.eInvoice.methodEInvoice',
  unknown: 'profile.fee.eInvoice.methodUnknown',
} as const satisfies Record<BillingMethod, string>;

/** A per-intent key: stable across retries of the SAME intent. */
export function mintIdempotencyKey(): string {
  return globalThis.crypto.randomUUID();
}

/** Copy strings mark paragraph breaks with a blank line (`\n\n`). */
export function paragraphs(text: string): string[] {
  return text.split('\n\n');
}

/**
 * Whether focus may be moved to a new home without taking it from the member:
 * it has fallen to <body> (its control unmounted) or it still sits on the
 * outcome `home` we put it on. A member who has since moved on keeps their place.
 */
export function focusIsUnclaimed(home: HTMLElement | null): boolean {
  const active = document.activeElement;
  if (active === null || active === document.body) return true;
  return home?.contains(active) ?? false;
}
